//@flow
import type { TableColumnTypes } from 'common/entity/generic/EntityImportContainer/types';
import { HomebaseImportHelper } from 'common/entity/homebaseMaster/HomebaseImportHelper';
import type { TableColumnType } from 'common/entity/generic/EntityImportContainer';
import { DayOfWeekType } from 'common/enums/DateTimeEnums';

const addTimeSlots = (
    defaultColumns: Array<TableColumnType>
): Array<TableColumnType> => {
    const slotColumns = Object.values(DayOfWeekType).map(dayOfWeek => {
        return {
            id: dayOfWeek,
            titleKey: 'masterHomebaseProperties.operatingSlots',
            titleId: dayOfWeek,
            accessor: ['timeSlots', dayOfWeek],
            templateValue:
                'masterImportTemplateValues.masterHomebase.operatingSlots',
            processCell: HomebaseImportHelper.processTimeSlots,
            validateCell: HomebaseImportHelper.validateEntityTimeSlots,
            serializeCell: HomebaseImportHelper.serializeMultiDaySlot,
            getModelFieldAccessor: HomebaseImportHelper.getTimeSlotsAccessor
        };
    });
    return [...defaultColumns, ...slotColumns];
};

const HOMEBASE_IMPORT_FORMAT: Array<TableColumnTypes> = addTimeSlots([
    {
        titleKey: 'masterHomebaseProperties.id',
        id: 'id',
        disabled: true,
        fixed: true,
        required: true,
        templateValue: 'masterImportTemplateValues.masterHomebase.id'
    },
    {
        titleKey: 'masterHomebaseProperties.code',
        id: 'code',
        disabled: true,
        templateValue: 'masterImportTemplateValues.masterHomebase.code'
    },
    {
        titleKey: 'masterHomebaseProperties.name',
        id: 'name',
        required: true,
        templateValue: 'masterImportTemplateValues.masterHomebase.name'
    },
    {
        titleKey: 'masterHomebaseProperties.type',
        id: 'type',
        required: true,
        templateValue: 'masterImportTemplateValues.masterHomebase.type',
        processCell: HomebaseImportHelper.processType
    },
    {
        titleKey: 'masterHomebaseProperties.crossDockType',
        id: 'crossDockInfo',
        accessor: ['crossDockInfo', 'typesSupported'],
        templateValue:
            'masterImportTemplateValues.masterHomebase.crossDockType',
        processCell: HomebaseImportHelper.processCrossDockInfo,
        serializeCell: HomebaseImportHelper.serializeCrossDockInfo,
        validateCell: HomebaseImportHelper.validateCrossDockInfo
    },
    {
        titleKey: 'masterHomebaseProperties.crossDockLowerThresh',
        id: 'crossDockLowerThresh',
        accessor: ['crossDockInfo', 'taskLimit', 'lowerThresh'],
        templateValue: 'masterImportTemplateValues.masterHomebase.minTaskCount'
    },
    {
        titleKey: 'masterHomebaseProperties.crossDockHigherThresh',
        id: 'crossDockHigherThresh',
        accessor: ['crossDockInfo', 'taskLimit', 'higherThresh'],
        templateValue: 'masterImportTemplateValues.masterHomebase.maxTaskCount',
        validateCell: HomebaseImportHelper.validateHigherThresh
    },
    {
        titleKey: 'masterHomebaseProperties.teamId',
        id: 'teams',
        required: true,
        templateValue: 'masterImportTemplateValues.masterHomebase.teams',
        processCell: HomebaseImportHelper.processTeams,
        validateCell: HomebaseImportHelper.validateTeamIds,
        serializeCell: HomebaseImportHelper.serializeTeams
    },
    {
        titleKey: 'masterHomebaseProperties.address.placeName',
        id: 'placeName',
        accessor: ['address', 'placeName'],
        templateValue:
            'masterImportTemplateValues.masterHomebase.address.placeName'
    },
    {
        titleKey: 'masterHomebaseProperties.address.address',
        id: 'formattedAddress',
        accessor: ['address', 'formattedAddress'],
        required: true,
        templateValue:
            'masterImportTemplateValues.masterHomebase.address.address'
    },
    {
        titleKey: 'masterHomebaseProperties.address.locality',
        id: 'localityName',
        accessor: ['address', 'localityName'],
        templateValue:
            'masterImportTemplateValues.masterHomebase.address.locality'
    },
    {
        titleKey: 'masterHomebaseProperties.address.city',
        id: 'city',
        accessor: ['address', 'city'],
        templateValue: 'masterImportTemplateValues.masterHomebase.address.city'
    },
    {
        titleKey: 'masterHomebaseProperties.address.state',
        id: 'state',
        accessor: ['address', 'state'],
        templateValue: 'masterImportTemplateValues.masterHomebase.address.state'
    },
    {
        titleKey: 'masterHomebaseProperties.address.pincode',
        id: 'pincode',
        accessor: ['address', 'pincode'],
        templateValue:
            'masterImportTemplateValues.masterHomebase.address.pincode'
    },
    {
        titleKey: 'masterHomebaseProperties.address.country',
        id: 'countryCode',
        accessor: ['address', 'countryCode'],
        templateValue:
            'masterImportTemplateValues.masterHomebase.address.country'
    },
    {
        titleKey: 'masterHomebaseProperties.latitude',
        id: 'lat',
        accessor: ['latLng', 'lat'],
        required: true,
        templateValue: 'masterImportTemplateValues.masterHomebase.latitude'
    },
    {
        titleKey: 'masterHomebaseProperties.longitude',
        id: 'lng',
        accessor: ['latLng', 'lng'],
        required: true,
        templateValue: 'masterImportTemplateValues.masterHomebase.longitude'
    },
    {
        titleKey: 'masterHomebaseProperties.tat',
        id: 'transactionDuration',
        templateValue: 'masterImportTemplateValues.masterHomebase.tat',
        processCell: HomebaseImportHelper.processMinutesToSeconds
    },
    {
        titleKey: 'masterHomebaseProperties.contactId',
        id: 'contactId',
        templateValue: 'masterImportTemplateValues.masterHomebase.contactId',
        accessor: ['contactId', 'contactId'],
        serializeCell: HomebaseImportHelper.serializeContactId,
        getModelFieldAccessor: HomebaseImportHelper.getContactIdAccessor,
        validateCellAsync: ({
            entity,
            header,
            onSuccess,
            onFailure,
            validateContactIds,
            clientId
        }) => {
            HomebaseImportHelper.validateEntityIdAsync({
                validator: validateContactIds,
                clientId,
                onSuccess,
                onFailure,
                entity,
                header
            });
        }
    }
]);

export default HOMEBASE_IMPORT_FORMAT;
